import type { AppConfig } from '../appConfig';

const configPrd: AppConfig = {
  env: 'prd',
  url: {
    userWeb: `https://explore.branq.jp`,
    customerWeb: `https://app.branq.jp`,
  },
  apiGateway: {
    region: 'ap-northeast-1',
    endpoint: `https://ljwuhxky1h.execute-api.ap-northeast-1.amazonaws.com/prd`,
  },
  s3: {
    region: 'ap-northeast-1',
    bucket: {
      staticContents: {
        name: `branq-${import.meta.env.VITE_STAGE}-static-contents`,
        endpoint: `https://d367whr2asz6yw.cloudfront.net`,
      },
      upload: {
        name: `branq-${import.meta.env.VITE_STAGE}-upload`,
      },
    },
  },
  ses: {
    from: {
      address: 'no-reply@branq.jp',
    },
  },
  cognito: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_Kr0sE2F1B',
    clientId: '5k1p0mdjkkuov581vjpk7rpjeb',
    identityPoolId: 'ap-northeast-1:84e0ef5c-f5ea-4821-ae50-6b49354482d7',
  },
};

export default configPrd;
